import { FC } from 'react';
import { Switch } from '../../../components/switch/switch';
import { getWeekDays } from '../../../helpers/date-time';
import { SchedulerInterface } from '../types';
import s from './scheduler-week.module.css';

export const SchedulerWeek: FC<Partial<SchedulerInterface>> = (props) => {
  const updatedWeeks = [...(props.days_of_week || Array.from({ length: 7 }, () => false))];

  const handleDayToggle = (index: number, isOn: boolean) => {
    updatedWeeks[index] = isOn;
    props.handleUpdateWeek?.(updatedWeeks);
  };

  return (
    <div className={s.feature}>
      <ul className={s.list}>
        {getWeekDays('dddd').map((day, index) => {
          return (
            <li key={index} className={s.item} data-name={`day-of-week-${index}`}>
              <span className={s.day}>{day}</span>
              <Switch
                isOn={updatedWeeks[index]}
                onToggle={(isOn) => handleDayToggle(index, isOn)}
                data-testid={`week-day-${index}`}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};
